export default __webpack_public_path__ + "static/media/home-user-img.419a1037.svg";